[
  {
    "code": "EE-37",
    "name": "Harjumaa"
  },
  {
    "code": "EE-39",
    "name": "Hiiumaa"
  },
  {
    "code": "EE-44",
    "name": "Ida-Virumaa"
  },
  {
    "code": "EE-51",
    "name": "Järvamaa"
  },
  {
    "code": "EE-49",
    "name": "Jõgevamaa"
  },
  {
    "code": "EE-59",
    "name": "Lääne-Virumaa"
  },
  {
    "code": "EE-57",
    "name": "Läänemaa"
  },
  {
    "code": "EE-67",
    "name": "Pärnumaa"
  },
  {
    "code": "EE-65",
    "name": "Põlvamaa"
  },
  {
    "code": "EE-70",
    "name": "Raplamaa"
  },
  {
    "code": "EE-74",
    "name": "Saaremaa"
  },
  {
    "code": "EE-78",
    "name": "Tartumaa"
  },
  {
    "code": "EE-82",
    "name": "Valgamaa"
  },
  {
    "code": "EE-84",
    "name": "Viljandimaa"
  },
  {
    "code": "EE-86",
    "name": "Võrumaa"
  }
]